import { gql } from "@apollo/client";

export const USER_DETAILS = gql`
  query User {
    user {
      edges {
        node {
          id
          name
          email
          roles
          salesforce_role
          frontend_preferences {
            language
          }
        }
      }
    }
  }
`;
